import { request, serviceName } from './base-config';

// 进度管理
export function getProjectProgress(data) {
  return request(`${serviceName}/screen/progress/project`, {
    method: 'GET',
    body: data,
  });
}
